import { render, staticRenderFns } from "./Concentration.vue?vue&type=template&id=6a0a7ee3&"
import script from "./Concentration.vue?vue&type=script&lang=js&"
export * from "./Concentration.vue?vue&type=script&lang=js&"
import style0 from "./Concentration.vue?vue&type=style&index=0&id=6a0a7ee3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports